<template>
  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-alert
      :title="Baslik+' Okunacak Bina Kaydı Yok'"
      type="success"
      :closable="false"
      v-if="!data">
    </el-alert>
    <el-table
      class="table-xs"
      style="width: 100%"
      width="100%"
      :data="Liste"
      v-if="data"
      row-key="id"
      :height="Height">
      <el-table-column
        prop="Adi"
        label="Bina Adı">
      </el-table-column>
      <el-table-column
        prop="Sorumlu"
        label="Sorumlu"
        width="100">
      </el-table-column>
      <el-table-column
        prop="oBolge"
        label="Bölge"
        width="120">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import Yukleniyor from "../../Doc/Yukleniyor";

export default {
  components: {Yukleniyor},
  props: ["Mod"],
  data() {
    return {
      Height: window.innerHeight - 190,
      Liste: null,
      data: false,
      lo: true,
      Baslik: "Bugün Takvim"
    }
  },
  methods: {
    SayfaYukle() {
      this.$store.dispatch("Get", {path: '_enerji/takvim/' + this.Mod})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Liste = response.Liste;
            this.lo = false;
            if (this.Liste) this.data = true;
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
    }
  },
  created() {

    if (this.Mod == 0) this.Baslik = 'Gecikmiş';
    if (this.Mod == 1) this.Baslik = 'Bugün';
    if (this.Mod == 2) this.Baslik = 'Bu Hafta';
    if (this.Mod == 3) this.Baslik = 'Bu Ay';
    this.SayfaYukle()
  },

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Panel/PanelTakvim.vue